import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ThemeConstantService } from '../../shared/services/theme-constant.service';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';

@Component({
  selector: 'app-vj-theme-layout',
  templateUrl: './vj-theme-layout.component.html',
 
})
export class VjThemeLayoutComponent {
  loadingStatus: boolean = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeConstantService,
    public spinnerService: PageLoadingService,
  ) {}

  ngOnInit() 
  
  {
    this.spinnerService.visibility.subscribe({
      next(status) {
        this.loadingStatus = status;
      },error(err) {
        
      },complete() {
        
      },
    });
  }
}
